import { BufferSourceConverter, Convert } from "pvtsutils";
export class ByteStream {
    get position() {
        return this.offset;
    }
    constructor(bytes) {
        this.offset = 0;
        this.view = BufferSourceConverter.toUint8Array(bytes);
    }
    read(size = 1) {
        const res = this.view.slice(this.offset, this.offset + size);
        this.offset = this.offset + res.length;
        return res;
    }
    readByte() {
        const bytes = this.read();
        if (!bytes.length) {
            throw new Error("End of stream");
        }
        return bytes[0];
    }
    readNumber(size) {
        const bytes = this.read(size);
        const hex = Convert.ToHex(bytes);
        return parseInt(hex, 16);
    }
    readEnd() {
        return this.read(this.view.length - this.offset);
    }
    reset() {
        this.offset = 0;
    }
}
